import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { FlightsModifyComponent } from '../../flights/flights-modify/flights-modify.component';
import { GuardService } from '../../service/guard.service';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateFlightModifyGuard {
  constructor(private readonly guardService: GuardService) {}
  canDeactivate(component: FlightsModifyComponent): Observable<boolean> | boolean {
    return this.guardService.canDeactivate(component);
  }
}
